/**
 * O download do PDF das orientações (E158.F3, GUS-191 CA13): ação secundária, com o aviso de uso
 * interno perto dela e sem confirmação a mais. O arquivo é o que o servidor nomeia.
 */
import { useState } from 'react';

import { Button } from '@/components/ui';
import { ptBR } from '@/i18n/pt-BR';
import { salvarArquivoBaixado, type ArquivoBaixado } from '@/lib/http_download';

const t = ptBR.orientacoes;

export interface BaixarOrientacoesProps {
  rotulo: string;
  baixar: () => Promise<ArquivoBaixado>;
  testId: string;
}

export function BaixarOrientacoes({ rotulo, baixar, testId }: BaixarOrientacoesProps) {
  const [baixando, setBaixando] = useState(false);
  const [erro, setErro] = useState(false);

  async function aoClicar(): Promise<void> {
    setBaixando(true);
    setErro(false);
    try {
      salvarArquivoBaixado(await baixar());
    } catch {
      setErro(true);
    } finally {
      setBaixando(false);
    }
  }

  return (
    <div>
      <p className="text-caption font-semibold text-warning-700">{t.aviso}</p>
      <Button
        className="mt-sc-2"
        variant="secondary"
        disabled={baixando}
        onClick={() => void aoClicar()}
        data-testid={testId}
      >
        {baixando ? t.fora.baixando : rotulo}
      </Button>
      {erro ? (
        <p role="alert" className="mt-sc-2 text-caption text-danger-700">
          {t.fora.erro}
        </p>
      ) : null}
    </div>
  );
}
